import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import LookupComponent from './tabs/LookupComponent'
import { Loader, Modal } from 'rsuite';
import { RiSettings3Line } from 'react-icons/ri'
import { convertToRaw } from 'draft-js';
import { useStore } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useHistory } from 'react-router-dom';
import { MdOutlineArrowBackIosNew } from 'react-icons/md'
import draftToHtml from 'draftjs-to-html';

import SupplyComponent from './tabs/SupplyComponent'
import RelatedSupplyComponent from './tabs/RelatedSupplyComponent'
import VendorExportModal from './modals/export-modal'
import CreateMasterModal from './modals/create-master'
import CreateChildSupplierModal from '../CreateChildSupplierComponent'
import CheckboxComponent from '../CommonComponents/CheckboxComponent'
import {
  getMasterSupplierDetailsById,
  getChildSuppliersWithMasterId,
  getRelatedSupplierDetailsById,
  approveSuppliers,
  rejectSuppliers,
  addSupplierHistory,
  updateSupplierDetailInfo,
  updateGlobalAcceptance,
  linkChildrensToPrimaryMaster,
  getCallersIdFromChildSupplier,
  getMatchedListSuppliersBySupplierIds,
  getSuppliersDataByIds
} from '../../redux/actions/vendor'
import ThreeStateToggleButton from '../CommonComponents/ThreeStateToggleButton'
import QaNotesModal from '../QualityComponent/modals/qa-notes-modal'
import MatchedChildListModal from './tabs/SupplyComponent/matched-child-list-modal'
import { getReadableTextForChangelog } from '../../services/helper'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { getContacts } from '../../redux/actions/contact'
import CommonContainer from '../CommonContainer'

const AssignVendorComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch()
  const [showExportModal, setShowExportModal] = useState(false)
  const [showCreateMasterModal, setShowCreateMasterModal] = useState(false)
  const [showCreateChildModal, setShowCreateChildModal] = useState(false)
  const [selectedChildVendorKeys, setSelectedChildVendorKeys] = useState([])
  const [selectedChildSuppliers, setSelectedChildSuppliers] = useState([])
  const [exportData, setExportData] = useState([])
  const [exportFileName, setExportFileName] = useState('')
  const [relatedSupplierData, setRelatedSupplierData] = useState({})
  const [relatedSupplierId, setRelatedSupplierId] = useState('')
  const [masterSupplierId, setMasterSupplierId] = useState('')
  const [isCreateNewLocationMaster, setIsCreateNewLocationMaster] = useState(false)
  const [isCreateMaster, setIsCreateMaster] = useState(false)
  const [showAdvanceSettings, setShowAdvanceSettings] = useState(false)
  const [isCollapsiblePanel, setIsCollapsiblePanel] = useState(true)
  const [isGlobalAcceptance, setIsGlobalAcceptance] = useState(null)
  const [isSendForReEnablement, setIsSendForReEnablement] = useState(null)
  const [isGlobalAcceptanceDisabled, setIsGlobalAcceptanceDisabled] = useState(false)
  const [isUpdatingAdvanceSettings, setIsUpdatingAdvanceSettings] = useState(false)
  const [qaStatus, setQaStatus] = useState('')
  const [qaType, setQaType] = useState('')
  const [showQaPromt, setShowQaPromt] = useState(false)
  const [isRelatedSupplierClicked, setIsRelatedSupplierClicked] = useState(false)
  const [currentTab, setCurrentTab] = useState('lookup')
  const [showDialog, setShowDialog] = useState(false)
  const [backdrop, setBackdrop] = React.useState('static');
  const [markAsReject, setMarkAsReject] = useState(false)
  const [callers, setCallers] = useState([])
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [pendingAction, setPendingAction] = useState(null)

  const param = window.location.href.split('suppliers')[1]
  const param1 = window.location.href.split('suppliers/relatedsupplier/')[1]

  const store = useStore().getState()
  const location = useLocation()
  const {
    app,
    domain: {
      currentDomain
    },
    vendor: {
      masterSupplierDetails,
      relatedSupplierDetails,
      isLoadingChildSupplier,
      isLoadingMasterDetail
    },
    auth: { user }
  } = store
  const { sideMenus } = app
  const currentPageName = sideMenus && sideMenus.find(menu => location.pathname.includes(menu.name))?.label

  useEffect(() => {
    setQaStatus('')
    if (param === '/newmastersupplier' || param === '/newchildsupplier') {
      setCurrentTab('lookup')
      setShowCreateMasterModal(false)
      setShowCreateChildModal(false)
      return
    }
    if ((param1 != undefined && param1 != '') || (param === 'relatedsupplier/' || param === '/relatedsupplier/')) {
      handleGoToRelatedSupply(param1)
    } else {
      if (param != undefined && param != '')
        handleGoToSupply(param)
    }
  }, [])

  const tabs = [
    {
      label: 'Supplier Matching',
      value: 'lookup',
    },
    {
      label: 'Master Supplier Details',
      value: 'supply',
    },
    {
      label: 'Related Supplier Details',
      value: 'relatedsupply',
    }
  ]

  const handleClickTab = (tab) => {
    tab !== currentTab && setCurrentTab(tab)
    if (tab !== currentTab && tab === 'relatedsupply') {
      setRelatedSupplierId('')
      setRelatedSupplierData({})
    }
    if (tab !== currentTab && tab === 'supply') {
      setMasterSupplierId('')
    }
  }

  const handleShowExportModal = (data, fileName) => {
    setExportData(data)
    setExportFileName(fileName)
    setShowExportModal(true)
  }

  const handleCloseExportModal = () => {
    setShowExportModal(false)
    setExportData([])
    setExportFileName('')
  }

  const handleShowCreateMasterModal = (checkedKeys, checkedSuppliers = []) => {
    setSelectedChildVendorKeys(checkedKeys)
    setSelectedChildSuppliers(checkedSuppliers)
    setShowCreateMasterModal(true)
    setIsCreateNewLocationMaster(false)
  }

  const handleCloseCreateMasterModal = () => {
    setShowCreateMasterModal(false)
    if (isCreateNewLocationMaster) {
      setCurrentTab('lookup');
    }
  }

  const handleGoToSupply = async (masterId, type = "master") => {
    if (type === 'location') {
      handleGoToRelatedSupply(masterId)
      return
    }

    if (typeof masterId === 'string' && masterId.includes('/')) {
      masterId = masterId.replaceAll('/', '')
    }

    handleClickTab('supply');

    if (masterId) {
      setMasterSupplierId(parseInt(masterId))
      const masterData = await dispatch(
        await getMasterSupplierDetailsById(masterId)
      )
      const masterChildData = await dispatch(
        await getChildSuppliersWithMasterId(masterId)
      )

      let listSupplierIds = masterChildData?.map((childData) => childData?.listSupplierId)
      let callers = await dispatch(getCallersIdFromChildSupplier(listSupplierIds)).then(res => res).catch(err => { if (err) { return [] } })
      let callerIds = callers?.callers.map(caller => caller?.callerAssigned)
      setCallers([...callerIds, user?.id])
      let supplierIds = [masterId]
      if (masterChildData && masterChildData?.length > 0) {
        const childIds = masterChildData?.map(sup => sup?.id)
        if (childIds && childIds?.length > 0) {
          supplierIds = [...supplierIds, ...childIds]
        }
      }
      if (supplierIds?.length) {
        await dispatch(getContacts({ supplierIds }))
      }
    } else {
      if (masterId === null) {
        setMasterSupplierId(null)
      } else {
        setMasterSupplierId('')
      }
    }
  }

  const handleGoToRelatedSupply = (relatedSupplierId) => {
    handleClickTab('relatedsupply');
    setRelatedSupplierId(relatedSupplierId)
    if (relatedSupplierId) {
      setIsRelatedSupplierClicked(true)
      dispatch(
        getRelatedSupplierDetailsById(parseInt(relatedSupplierId))
      ).then(async (res) => {
        setIsSendForReEnablement(res?.masterSupplierInfo?.detailInfo?.isSendToReEnablement)
        await dispatch(getContacts({ supplierIds: [relatedSupplierId], supType: 'related' }))
        if (res?.masterSupplierInfo?.baseInfo?.id) {
          await dispatch(getContacts({ supplierIds: [res?.masterSupplierInfo?.baseInfo?.id], supType: 'relatedMaster' }))
        }
        setRelatedSupplierData(res)
        setIsRelatedSupplierClicked(false)
      }).catch((err) => {
        setRelatedSupplierData({})
        setIsRelatedSupplierClicked(false)
      })
    }
  }

  const checkedRelatedSupplierData = (data) => {
    if (data.isAcceptGlobalAcceptance !== undefined && data.isAcceptGlobalAcceptance === false && !data?.data[0]?.primaryMasterId) {
      setSelectedChildVendorKeys(data?.data[0]?.id)
      setSelectedChildSuppliers(data?.data[0])
      setShowCreateMasterModal(true)
      setIsCreateNewLocationMaster(true)
    } else {
      if (data?.data && data?.data.length > 0) {
        handleGoToRelatedSupply(data?.data[0]?.id)
      }
    }
  }

  useEffect(() => {
    if (param === '' && (history?.location?.pathname === '/suppliers/' || history?.location?.pathname === '/suppliers')) {
      setQaStatus('')
      setShowAdvanceSettings(false)
      setCurrentTab('lookup')
      setShowCreateMasterModal(false)
      setShowCreateChildModal(false)
    } else {
      if ((param1 !== undefined && param1 !== '' && !isRelatedSupplierClicked)) {
        handleGoToRelatedSupply(param1)
      } else {
        return
      }
    }
  }, [param])

  const handleShowCreateChildModal = () => {
    setShowCreateChildModal(true)
  }

  const handleCloseCreateChildModal = () => {
    setShowCreateChildModal(false)
  }

  const handleGlobalAcceptanceChange = (checked) => {
    if (checked || checked === null) {
      setIsCollapsiblePanel(true)
    } else {
      setIsCollapsiblePanel(false)
    }
  }

  const onApproveClick = () => {
    setQaType('approve')
    handleSubmitQA('', 'approve')
  }

  const [matchedChildListData, setMatchedChildListData] = useState([]);
  const [matchedChildListModal, setMatchedChildListModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleInCallsStatusClick = async () => {
    setIsLoading(true)
    const childSupplierIds = masterSupplierDetails?.childVendors.map(vendor => vendor.id);
    childSupplierIds.push(masterSupplierDetails?.baseInfo?.id)
    const listSupplierIds = []
    masterSupplierDetails?.baseInfo?.listSupplierId && (listSupplierIds.push(masterSupplierDetails?.baseInfo?.listSupplierId));
    if (childSupplierIds.length > 0) {
      await dispatch(getMatchedListSuppliersBySupplierIds({ supplierIds: childSupplierIds, listSupplierIds })).then((res) => {
        if (res?.listSuppliers?.length > 0) {
          if (res?.listSuppliers?.length > 1) {
            setMatchedChildListData(res?.listSuppliers);
            setMatchedChildListModal(true);
          } else {
            handleCallClick(res?.listSuppliers[0]?.id, res?.listSuppliers[0]?.listId, "call", res?.listSuppliers[0])
          }
        }
        else if (masterSupplierDetails?.detailInfo?.isSendToReEnablement && masterSupplierDetails?.baseInfo?.isInCalls) {
          history.push({ pathname: `/lists/insequence/addcallerdetails/${masterSupplierDetails?.baseInfo?.id}`, state: { matchedSupplierId: masterSupplierDetails?.baseInfo?.id, activeKey: 'reenablement' } })
        }
      }).catch((err) => {
        console.log("err => ", err)
        setIsLoading(false)
        toast.show({
          title: 'Danger',
          description: `Unable To get Data`,
        })
      })
    }
  };

  const onListSupplierOpen = async (vendor) => {
    if (vendor?.vendorsInCall?.status?.toLowerCase() === "approved") {
      toast.show({
        title: 'Warning',
        description: 'This list supplier is already approved from calls'
      })
      return;
    }
    const type = vendor?.vendorsInCall?.status?.toLowerCase() === "in calls" ? "call" : "qa";
    handleCallClick(vendor?.id, vendor?.listId, type, vendor)
  }

  const handleCallClick = async (vendorId, listId, type = 'call', listSupplierData) => {
    const vendorInCallData = listSupplierData
    if (vendorInCallData?.matchedSupplierId) {
      await dispatch(getSuppliersDataByIds([vendorInCallData?.matchedSupplierId])).then((masterSup) => {
        const matchedSupplierId = masterSup[0]?.isMaster ? vendorInCallData?.matchedSupplierId : masterSup[0]?.masterId
        callClickHandler(vendorInCallData, type, listId, vendorId, matchedSupplierId)
      }).catch(err => {
        toast.show({
          title: 'Warning',
          description: 'Failed to get Supplier Data'
        })
      })
    } else {
      callClickHandler(vendorInCallData, type, listId, vendorId, vendorInCallData?.matchedSupplierId)
    }
  }

  const callClickHandler = (vendorInCallData, type, listId, vendorId, matchedSupplierId) => {
    const vendorInCall = vendorInCallData?.vendorsInCall
    vendorInCallData.partnerName = vendorInCallData?.list?.partner?.partnerName
    vendorInCallData.companyName = vendorInCallData?.list?.companyName
    vendorInCall['partnerName'] = vendorInCallData?.partnerName
    vendorInCall['companyName'] = vendorInCallData?.companyName
    vendorInCall['nameUse'] = vendorInCallData?.list?.nameUse
    vendorInCall['contactName'] = vendorInCallData?.supplierDetail?.contactNameOld ? vendorInCallData?.supplierDetail?.contactNameOld : 'NONE'
    history.push({ pathname: `/lists/insequence/${type === 'qa' ? 'qacallerdetails' : 'addcallerdetails'}/${vendorId}`, state: { matchedSupplierId: matchedSupplierId, vendorInCall: vendorInCall, from: history.location.pathname, vendorId: vendorId } })
  }

  const onRejectClick = () => {
    setShowQaPromt(true)
    setQaType('reject')
  }

  const handleSubmitQA = (qaNotes, type, isReenable = false) => {
    let tmpQaType = type ? type : qaType
    var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
    let oldStatus = qaStatus
    let id = currentTab === 'supply' ? parseInt(masterSupplierDetails?.baseInfo?.id) : parseInt(relatedSupplierId)
    var editorContent = qaNotes ? draftToHtml(convertToRaw(qaNotes.getCurrentContent())) : '';
    if (tmpQaType === 'approve') {
      editorContent = `<p><b><em> Approved By ${userName} </em></b></p>` + editorContent;
      setQaStatus('')
      dispatch(
        approveSuppliers({
          ids: [id],
          supplierType: currentTab === 'supply' ? 'singleMaster' : 'singleChild'
        })
      ).then(() => {
        dispatch(
          addSupplierHistory({
            supplierId: id,
            note: editorContent,
            noteType: 'changelog'
          }, false)
        )
      }).catch(() => {
        setQaStatus(oldStatus)
      })
    } else if (tmpQaType === 'reject') {
      let isMaster = currentTab === 'supply' ? true : false
      let isLocationMaster = currentTab === 'supply' ? false : (relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.isMaster && relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.primaryMasterId) ? true : false
      editorContent = `<p><b><em> Rejected By ${userName} </em></b></p>` + editorContent;
      if (isReenable) editorContent += `<p>(sent to Reenablement)</p>`;
      setQaStatus('')
      dispatch(
        rejectSuppliers({
          ids: [id],
          supplierType: currentTab === 'supply' ? 'singleMaster' : 'singleChild',
          isReenable
        })
      ).then(() => {
        dispatch(
          addSupplierHistory({
            supplierId: id,
            note: editorContent,
            noteType: 'changelog',
            isMaster,
            isLocationMaster,
            supplierName: currentTab === 'supply' ? masterSupplierDetails?.baseInfo?.suppliername : relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.suppliername
          })
        )
      }).catch(() => {
        setQaStatus(oldStatus)
      })
    }
  }

  const executeAdvanceSaveActions = async (
    oldSendForReEnablement,
    oldGlobalAcc,
    supId,
    detailId,
    detailData,
    reenablementNotes
  ) => {
    setIsUpdatingAdvanceSettings(true);
    if (isSendForReEnablement !== oldSendForReEnablement) {
      try {
        await dispatch(updateSupplierDetailInfo({
          supplierDetailId: detailId,
          supplierId: supId,
          detailData: detailData,
          isSendForReEnablement: isSendForReEnablement
        }));

        await dispatch(
          addSupplierHistory({
            supplierId: currentTab === 'supply' ? masterSupplierDetails?.baseInfo?.id : relatedSupplierData?.masterSupplierInfo?.baseInfo?.id,
            note: reenablementNotes,
            noteType: 'changelog'
          })
        );

        toast.show({
          title: 'Success',
          description: 'Send for Re-Enablement updated successfully!'
        });
      } catch (error) {
        toast.show({
          title: 'Error',
          description: 'Failed to update Send for Re-Enablement!'
        });
      }
    }

    if (isGlobalAcceptance !== oldGlobalAcc) {
      try {
        await dispatch(
          updateGlobalAcceptance({
            supplierId: currentTab === 'supply' ? supId : relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id,
            isGlobalAcceptance: isGlobalAcceptance,
            supType: currentTab === 'supply' ? 'master' : 'related'
          })
        );

        let changeLogNotes = '';
        var oldReadableText = getReadableTextForChangelog(currentTab === 'supply' ? masterSupplierDetails?.cardInfo?.isAcceptGlobalAcceptance : relatedSupplierData?.masterSupplierInfo?.cardInfo?.isAcceptGlobalAcceptance);
        var newReadableText = getReadableTextForChangelog(isGlobalAcceptance);
        changeLogNotes += 'Global Acceptance updated from ' + oldReadableText + ' to ' + newReadableText;

        if (changeLogNotes !== '') {
          await dispatch(
            addSupplierHistory({
              supplierId: currentTab === 'supply' ? masterSupplierDetails?.baseInfo?.id : relatedSupplierData?.masterSupplierInfo?.baseInfo?.id,
              note: changeLogNotes,
              noteType: 'changelog'
            })
          );
        }

        if (currentTab === 'supply') {
          var childsLinkedToLocMaster = masterSupplierDetails?.childVendors?.filter(child => child.primaryMasterId !== null);
          handleGlobalAcceptanceChange(isGlobalAcceptance);
          if (isGlobalAcceptance && childsLinkedToLocMaster.length > 0) {
            await dispatch(linkChildrensToPrimaryMaster({
              masterId: masterSupplierDetails.baseInfo.id
            }));
          }
        }
      } catch (error) {
        console.error('Failed to update global acceptance:', error);
      }
    }

    setIsUpdatingAdvanceSettings(false);
    setShowAdvanceSettings(false);
  };

  const handleAdvanceSaveClick = async (qaNotes) => {
    var editorContent = qaNotes ? draftToHtml(convertToRaw(qaNotes.getCurrentContent())) : '';
    let oldSendForReEnablement = currentTab === 'supply' ? masterSupplierDetails?.detailInfo?.isSendToReEnablement : relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.isSendToReEnablement;
    let oldGlobalAcc = currentTab === 'supply' ? masterSupplierDetails?.cardInfo?.isAcceptGlobalAcceptance : relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.cardInfo?.isAcceptGlobalAcceptance;
    let supId = currentTab === 'supply' ? parseInt(masterSupplierDetails?.baseInfo?.id) : parseInt(relatedSupplierId);
    let detailId = currentTab === 'supply' ? (masterSupplierDetails?.detailInfo?.id || -1) : (relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.['id'] || -1);
    let detailData = currentTab === 'supply' ? {
      ...masterSupplierDetails?.detailInfo,
      approvedByQA: markAsReject ? 7 : masterSupplierDetails?.detailInfo?.approvedByQA,
      isSendToReEnablement: isSendForReEnablement,
    } : {
      ...relatedSupplierDetails?.relatedSupplierInfo?.detailInfo,
      isSendToReEnablement: isSendForReEnablement,
    };


    var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '');
    let changeLogNotes = '';
    changeLogNotes += (masterSupplierDetails?.baseInfo?.suppliername || 'N/A') +
      ' has been ' + (detailData?.isSendToReEnablement ? 'sent to' : 'removed from') +
      ' Reenablement by User: ' + userName;

    if (detailData?.isSendToReEnablement !== true) {
      setPendingAction(() => async () => {
        await executeAdvanceSaveActions(
          oldSendForReEnablement,
          oldGlobalAcc,
          supId,
          detailId,
          detailData,
          changeLogNotes
        );
      });
      setShowConfirmationModal(true);
      return;
    } else {
      changeLogNotes += ', ' + editorContent
      await executeAdvanceSaveActions(
        oldSendForReEnablement,
        oldGlobalAcc,
        supId,
        detailId,
        detailData,
        changeLogNotes
      );
    }
  };

  const setInitialAdvanceInfo = useCallback(async (supplierDetails, tab) => {
    let qaStatus = (supplierDetails?.baseInfo?.isInCalls || supplierDetails?.detailInfo?.approvedByQA === 9) ? 'In Calls' : supplierDetails?.detailInfo?.approvedByQA === 8 ? 'Approved' : supplierDetails?.detailInfo?.approvedByQA === 7 ? 'Rejected' : 'Pending'
    let globalAcc = tab === 'supply' ? supplierDetails?.cardInfo?.isAcceptGlobalAcceptance : supplierDetails?.masterSupplierInfo?.cardInfo?.isAcceptGlobalAcceptance
    let sendToReEnablement = supplierDetails?.detailInfo?.isSendToReEnablement
    setQaStatus(qaStatus)
    if (currentTab !== 'relatedsupply') {
      setIsSendForReEnablement(sendToReEnablement)
    }
    // currentTab !== 'relatedsupply' && setIsSendForReEnablement(sendToReEnablement)
    setIsGlobalAcceptance(globalAcc)

    if (tab === 'supply') {
      setIsGlobalAcceptanceDisabled(false)
      setIsCollapsiblePanel(supplierDetails?.cardInfo?.isAcceptGlobalAcceptance === false ? false : true)
    } else {
      if (Object.keys(relatedSupplierData).length > 0 ? (relatedSupplierData?.primaryMasterInfo && relatedSupplierData?.masterSupplierInfo?.baseInfo?.masterId !== null) : (supplierDetails?.primaryMasterInfo && supplierDetails?.masterSupplierInfo?.baseInfo?.masterId !== null)) {
        if (Object.keys(relatedSupplierData).length > 0) {
          setIsGlobalAcceptanceDisabled(relatedSupplierData?.primaryMasterInfo?.cardInfo?.isAcceptGlobalAcceptance !== false ? true : false)
        } else {
          setIsGlobalAcceptanceDisabled(supplierDetails?.primaryMasterInfo?.cardInfo?.isAcceptGlobalAcceptance !== false ? true : false)
        }
      } else {
        setIsGlobalAcceptanceDisabled(true)
      }
    }
  }, [])

  const handleAdvanceCancelClick = () => {
    setInitialAdvanceInfo(currentTab === 'supply' ? masterSupplierDetails : relatedSupplierDetails?.relatedSupplierInfo, currentTab)
  }

  useEffect(() => {
    if (currentTab === 'lookup' || isLoadingChildSupplier || isLoadingMasterDetail) return
    if (currentTab === 'supply') {
      if (!masterSupplierDetails || Object.keys(masterSupplierDetails).length === 0 || (masterSupplierId && masterSupplierDetails?.baseInfo?.['id'] !== parseInt(masterSupplierId))) {
        return
      }
    } else {
      if (!relatedSupplierDetails || Object.keys(relatedSupplierDetails).length === 0 || relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.['id'] !== parseInt(relatedSupplierId)) {
        return
      }
    }
    setInitialAdvanceInfo(currentTab === 'supply' ? masterSupplierDetails : relatedSupplierDetails?.relatedSupplierInfo, currentTab)
  }, [masterSupplierDetails, relatedSupplierDetails, currentTab, setInitialAdvanceInfo])

  const handleOnAssignedMaster = (relatedSupplierId) => {
    if (relatedSupplierId) {
      dispatch(
        getRelatedSupplierDetailsById(parseInt(relatedSupplierId))
      ).then((res) => {
        setIsSendForReEnablement(res?.masterSupplierInfo?.detailInfo?.isSendToReEnablement)
        setRelatedSupplierData(res)
      }).catch((err) => {
        console.log(err)
      })
    }
  }

  let isSaveDisabled = currentTab === 'supply' ?
    (masterSupplierDetails?.detailInfo?.isSendToReEnablement === isSendForReEnablement && masterSupplierDetails?.cardInfo?.isAcceptGlobalAcceptance === isGlobalAcceptance)
    : (relatedSupplierDetails?.relatedSupplierInfo?.detailInfo?.isSendToReEnablement === isSendForReEnablement && relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.cardInfo?.isAcceptGlobalAcceptance === isGlobalAcceptance)

  return (
    <CommonContainer>
      <div className={`assign-vendor-component pe-4 pe-sm-5 ${isLoading ? 'position-relative loading' : ''}`}>
        {isLoading && <Loader size="md" className="top-33 loader-component" />}

        {/* Confirmation Modal */}
        <Modal show={showConfirmationModal} onHide={() => {
          setShowConfirmationModal(false);
          handleAdvanceCancelClick();
        }}>
          <Modal.Header className={`${isUpdatingAdvanceSettings ? 'position-relative loading' : ''}`}>
            {isUpdatingAdvanceSettings && <LoaderComponent />}
            <h2 className='mb-0'>The supplier has not completed the reenablement campaign. By changing this, you'll stop the recampaign process and lose any acceptance or remittance gathered since being sent to reenablement. Do you want to continue?</h2>
            <div className='mt-4'>
              <button
                className="pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white float-end width-100"
                onClick={() => {
                  setShowConfirmationModal(false);
                  handleAdvanceCancelClick();
                }}>
                Cancel
              </button>
              <button className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto float-end width-100' onClick={() => {
                setShowConfirmationModal(false);
                if (pendingAction) {
                  pendingAction();
                }
              }}>Ok</button>
            </div>
          </Modal.Header>
        </Modal>

        {showDialog && <QaNotesModal
          show={showDialog}
          onClose={() => { setShowDialog(false) }}
          onDone={handleAdvanceSaveClick}
          qaReject={false}
          page='masterSupplierDetail'
          setMarkAsReject={setMarkAsReject}
        />}

        <div className='current-page-title d-flex align-items-center'>
          {(showCreateMasterModal || showCreateChildModal) ? <div><MdOutlineArrowBackIosNew color="#78B1E4" size={16} onClick={() => showCreateMasterModal ? setShowCreateMasterModal(false) : setShowCreateChildModal(false)} /> {isCreateNewLocationMaster ? 'New Location-Based Master Supplier' : showCreateChildModal ? 'Add Child Supplier' : 'New Master Supplier'} </div> : 'Suppliers'}
          {showCreateChildModal && (
            <div className='ms-auto'>
              <CheckboxComponent
                label='Create Master Supplier'
                onChange={(checked) => { setIsCreateMaster(checked) }}
                checked={isCreateMaster}
              />
            </div>
          )}
          {(currentTab === 'supply' || currentTab === 'relatedsupply') && (
            <div role="button" className='ms-auto d-flex gap-2' onClick={() => { setShowAdvanceSettings(!showAdvanceSettings); handleAdvanceCancelClick(); }}>
              <RiSettings3Line color='#65B3E9' />
              <h3 className='text-black fw-bold mb-0'>Advanced {currentTab === 'relatedsupply' && 'Master'} Settings </h3>
            </div>
          )}
        </div>

        {showAdvanceSettings && (currentTab === 'supply' || currentTab === 'relatedsupply') && (
          <div className={`position-relative d-flex flex-column gap-4 bg-white rounded shadow ms-auto p-3 supplier-advance-settings ${isUpdatingAdvanceSettings ? ' loading' : ''}`}>
            {isUpdatingAdvanceSettings && <LoaderComponent />}
            <div className='d-flex gap-2 align-items-center'>
              <h4 className='fw-bold mb-0 text-black'>Send for Re-Enablement</h4>
              <ThreeStateToggleButton customClass='ms-auto' isDisabled={(qaStatus === 'In Calls' && !isSendForReEnablement) || currentTab === 'relatedsupply'} checked={isSendForReEnablement} onChange={(checked) => { setIsSendForReEnablement(checked); checked && setShowDialog(true) }} />
            </div>
            <div className='d-flex gap-2 align-items-center'>
              <h4 className='fw-bold mb-0 text-black'>Global Acceptance</h4>
              <ThreeStateToggleButton customClass='ms-auto' checked={isGlobalAcceptance} onChange={(checked) => { setIsGlobalAcceptance(checked); }} isDisabled={isGlobalAcceptanceDisabled || currentTab === 'relatedsupply'} />
            </div>
            {currentTab !== 'relatedsupply' && (
              <div className='d-flex gap-2 ms-auto'>
                <button type="button" className="bg-light-gray h4 mb-0 me-0 ps-3 pe-3 pt-2 pb-2 ps-sm-4 pe-sm-4 rounded text-white" onClick={() => { handleAdvanceCancelClick() }} >
                  Cancel
                </button>
                <button type="button" className="btn-green h4 mb-0 ps-3 pe-3 pt-2 pb-2 ps-sm-4 pe-sm-4 rounded" onClick={() => { handleAdvanceSaveClick() }} disabled={isSaveDisabled}>
                  Save
                </button>
              </div>
            )}
          </div>
        )}

        {(!showCreateMasterModal && !showCreateChildModal) && (
          <div className="page-tabs gap-4 gap-md-5">
            {tabs.map(tab => (
              <button
                key={tab.value}
                type="button"
                className={`page-tab me-0${currentTab === tab.value ? ' selected' : ''}`}
                onClick={() => { handleClickTab(tab.value) }}
              >
                {tab.label}
              </button>
            ))}
            {(currentTab === 'supply') && (
              <div className='d-flex align-items-center ms-auto approve-reject-section-parent'>
                <div className='d-flex gap-3 align-items-center'>
                  <h4 className='fw-bold mb-0 text-black'>QA Status</h4>
                  <button className={`h4 mb-0 fw-bold rounded text-white width-100${qaStatus ? (qaStatus === 'In Calls' ? ' bg-blue' : qaStatus === 'Rejected' ? ' bg-red' : qaStatus === 'Approved' ? ' btn-green' : ' bg-yellow') : ' fs-0 bg-white'}`} onClick={() => qaStatus === 'In Calls' && (handleInCallsStatusClick())}> {qaStatus ? qaStatus : <Loader size="sm" />}</button>
                </div>

                {qaStatus === 'Rejected' && ((currentDomain?.roleId === 3 || currentDomain?.roleName === 'admin') || (currentDomain?.roleId === 2 || currentDomain?.roleName === 'moderator')) && (
                  <div className='d-flefx gap-3 approve-reject-section ms-auto'>
                    <button className='h4 mb-0 fw-bold rounded btn-green text-white ms-auto float-end width-100' onClick={() => onApproveClick()}>Approve</button>
                  </div>
                )}

                {qaStatus === 'Pending' && ((currentDomain?.roleId === 3 || currentDomain?.roleName === 'admin') || (currentDomain?.roleId === 2 || currentDomain?.roleName === 'moderator')) && (
                  <div className='d-flefx gap-3 approve-reject-section ms-auto'>
                    <button className='h4 mb-0 fw-bold rounded btn-green text-white ms-auto float-end width-100' onClick={() => onApproveClick()}>Approve</button>
                    <button className='h4 mb-0 fw-bold rounded bg-red text-white ms-auto float-end me-3 width-100' onClick={() => onRejectClick()}>Reject</button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {currentTab === 'lookup' && (!showCreateMasterModal && !showCreateChildModal) && (
          <LookupComponent
            onShowExportModal={handleShowExportModal}
            onShowCreateMasterModal={handleShowCreateMasterModal}
            onGoToSupply={handleGoToSupply}
            checkedRelatedSupplierData={checkedRelatedSupplierData}
            onShowCreateChildModal={handleShowCreateChildModal}
          />
        )}

        {currentTab === 'supply' && (!showCreateMasterModal && !showCreateChildModal) && (
          <SupplyComponent
            checkedRelatedSupplierData={checkedRelatedSupplierData}
            masterSupplierId={masterSupplierId}
            collapsiblePanel={isCollapsiblePanel}
            qaStatus={qaStatus}
            callers={callers}
          />
        )}

        {currentTab === 'relatedsupply' && (
          <RelatedSupplyComponent
            relatedSupplierData={relatedSupplierData}
            relatedSupplierId={relatedSupplierId}
            onAssignedMaster={handleOnAssignedMaster}
            callers={callers}
          />
        )}

        <VendorExportModal
          show={showExportModal}
          exportData={exportData}
          onClose={handleCloseExportModal}
          fileName={exportFileName}
        />

        {showCreateMasterModal && (
          <CreateMasterModal
            show={showCreateMasterModal}
            onClose={handleCloseCreateMasterModal}
            selectedKeys={selectedChildVendorKeys}
            isCreateNewLocationMaster={isCreateNewLocationMaster}
            selectedChildSuppliers={selectedChildSuppliers}
          />
        )}

        {showCreateChildModal && (
          <CreateChildSupplierModal
            show={showCreateMasterModal}
            onClose={handleCloseCreateChildModal}
            isCreateMaster={isCreateMaster}
          />
        )}

        {showQaPromt && (
          <QaNotesModal
            show={showQaPromt}
            onClose={() => setShowQaPromt(false)}
            onDone={handleSubmitQA}
            qaReject={true}
            page='masterSupplierDetail'
          />
        )}

        {matchedChildListModal && (
          <MatchedChildListModal
            show={matchedChildListModal}
            onClose={() => { setMatchedChildListModal(false); setIsLoading(false) }}
            matchedChildListData={matchedChildListData}
            onOpen={(vendor) => onListSupplierOpen(vendor)}
          />
        )}
      </div>
    </CommonContainer>
  )
}

export default AssignVendorComponent